import React from 'react';
import './loading.css'; // We will create this CSS file next

function LoadingScreen(props) {
  return (
    <>
      <div id="loading" className="loading-container">
        <img src="/img/loading/cupLogo.gif" width="72" height="72" alt="Loading..." />
        <span>Loading</span>
      </div>
    </>
  )
}
export default LoadingScreen;